import React from "react";

export const ErrorIcon = ({...props}) => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13.5" cy="13.5" r="13.5" fill="#FF4747" />
      <path
        d="M12.6 16.6825L12.3273 6H14.6727L14.4 16.6825H12.6ZM12.3818 20.6662C12.1273 20.4288 12 20.132 12 19.776C12 19.4199 12.1273 19.1306 12.3818 18.908C12.6364 18.6706 13 18.5519 13.4727 18.5519C13.9636 18.5519 14.3364 18.6706 14.5909 18.908C14.8636 19.1306 15 19.4199 15 19.776C15 20.132 14.8636 20.4288 14.5909 20.6662C14.3364 20.8887 13.9636 21 13.4727 21C13 21 12.6364 20.8887 12.3818 20.6662Z"
        fill="white"
      />
    </svg>
  );
};
